import {computed, ComputedRef, inject, InjectionKey, MaybeRefOrGetter, provide, toValue} from "vue";
import {MSSanteSource} from "@/mssante/interfaces/SecureMessaging";

const MSSANTE_SOURCE: InjectionKey<ComputedRef<MSSanteSource | undefined>> = Symbol('mssante-source');

/**
 * Declare what the MSSanté messages written below are about, e.g. the program a page
 * shows: every dialog opened under it then links its message to that program.
 *
 * @param source - The source, reactive.
 */
export function provideMSSanteSource(source: MaybeRefOrGetter<MSSanteSource | undefined>): void {
    provide(MSSANTE_SOURCE, computed(() => toValue(source)));
}

/**
 * The MSSanté source declared by an enclosing page, if any.
 */
export function useMSSanteSource(): ComputedRef<MSSanteSource | undefined> {
    return inject(MSSANTE_SOURCE, computed(() => undefined));
}
